import { useSpecialsManagerAPIInterface } from "@dealer-center/ddc-pages-specials-manager-fetch";
import type { SpecialsManagerAPIInterfaceInternal } from "@dealer-center/ddc-pages-specials-manager-interface";
import { Box, Modal, ModalContent } from "@dealer-center/core-components";
import { useNavigate, useParams } from "react-router-dom";

export const PagesSpecialsManagerUiModal = () => {
  const { searchValue, record } = useParams();
  const { data } = useSpecialsManagerAPIInterface({
    searchValue
  });
  const navigate = useNavigate();
  const selectedRecord = data?.find(
    (item: SpecialsManagerAPIInterfaceInternal) => item.key === record
  );

  return (
    <Modal
      header={`Images for ${selectedRecord?.name}`}
      show={!!selectedRecord}
      size="large"
      onHide={() => navigate("..")}
    >
      <ModalContent>
        <Box
          sx={{
            display: "grid",
            gap: 2,
            gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))"
          }}
        >
          {selectedRecord?.images.map((image, i) => (
            <Box
              key={image}
              sx={{
                overflow: "hidden",
                position: "relative",
                paddingBottom: "100%"
              }}
            >
              <img
                alt={selectedRecord?.name}
                src={image}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover"
                }}
              />
            </Box>
          ))}
        </Box>
      </ModalContent>
    </Modal>
  );
};
